
import React, { useState } from "react";
import classes from './Header.module.css'
import MenuLogo from "./MenuLogo";
import useReplaceNumChar from '../../hooks/useReplaceNumChar'
import { useSelector } from 'react-redux';
import { login } from '../../store/auth-actions';
import UserInfo from '../UI/UserInfo'
import FAQBtn from "../Pages/Dashboard/HeaderActionBar/Icons/FAQBtn";
import ShareBtn from "../Pages/Dashboard/HeaderActionBar/Icons/ShareBtn";
import SupportBtn from "../Pages/Dashboard/HeaderActionBar/Icons/SupportBtn";
import SettingBtn from "../Pages/Dashboard/HeaderActionBar/Icons/SettingBtn";
import MessagesBtn from "../Pages/Dashboard/HeaderActionBar/Icons/MessagesBtn";
import ToDoBtn from "../Pages/Dashboard/HeaderActionBar/Icons/ToDoBtn";
import SearchBtn from "../Pages/Dashboard/HeaderActionBar/Icons/SearchBtn";
import UserProfile from "../lms-shared/UI/UserProfile";
import defaultAvatar from '../../assests/user-profile/default-avatar.png'
import { onKeyDown } from '../../service';

const Header = ({ children }) => {
    const numClass = useReplaceNumChar()
    const [shwoLogoMenu, setShowLogoMenu] = useState(false)
    const { user, isAuthenticated } = useSelector(state => state.auth);
    const [showUserInfo, setShowUserInfo] = useState(false);
    const logo = useSelector(state => state.application.logo);

    function showUserInfoFunc(e) {
        e.stopPropagation();
        setShowUserInfo((prevShowUserInfo) => !prevShowUserInfo)
    }
    return (
        <>
            <div className={classes.Header}>
                <div className={classes.ProfileAndIconsContainer}>
                    {isAuthenticated ?
                        <div className={classes.UserInfo} onClick={(e) => showUserInfoFunc(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => showUserInfoFunc(e))}>
                            <UserProfile width="47px"
                                image={user.profileImage ?
                                    `${user.profileImage}` :
                                    defaultAvatar}
                            />
                            <div className={classes.UserDetails}>
                                <div> {user.firstName} {user.lastName}</div>
                                {user?.class ? <div>{numClass(user.class)}'</div> : ''}
                            </div>
                            <div className={classes.OpenIcon}></div>
                        </div>
                        : <div className={classes.UserDetails} onClick={login} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, login)}></div>}
                    {children}
                </div>
                <div className={classes.MenuAndSaveContainer}>
                    <div className={classes.ActionIcons}>
                        <SearchBtn />
                        <SettingBtn />
                        <ToDoBtn />
                        {/* <ShareBtn /> */}
                        <SupportBtn />
                        <FAQBtn />
                        <MessagesBtn />
                    </div>
                    <div className={classes.Logo} onClick={() => setShowLogoMenu(true)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowLogoMenu(true))}>
                        <div className={classes.HighTechLogo} style={{ backgroundImage: `url(${logo})` }}></div>
                        <div className={classes.OpenIcon}></div>
                    </div>
                </div>
            </div>

            {shwoLogoMenu && <MenuLogo setShowLogoMenu={setShowLogoMenu}></MenuLogo>}

            {showUserInfo &&
                <div className={classes.UserPopup} >
                    <div className={classes.UserPopupContainer}>
                        <div className={classes.UserDataPopup} onClick={() => setShowUserInfo(false)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowUserInfo(false))}>
                            <UserProfile width="47px"
                                image={user.profileImage ?
                                    `${user.profileImage}` :
                                    defaultAvatar}
                            />
                            <div className={classes.UserDetailsPopUp}>
                                <div className={classes.UserDetailsTextWarp}> {user.firstName} {user.lastName}</div>
                                {user?.class ? <div className={classes.UserDetailsTextWarp}>{numClass(user.class)}'</div> : ''}
                            </div>
                            <div className={classes.CloseIcon}></div>
                        </div>
                        <div className={classes.ProfileHeader}>פרופיל</div>
                        <UserInfo hideUserInfo={true} />
                    </div>
                </div>}
        </>
    )
}
export default Header